//ms
export const SWAP_CALCULATOR_POOLING_INTERVAL = 60000;
//ms
export const SWAP_CALCULATOR_DEBOUCED_TIME = 150;
//days
export const ONE_DAY = 1;
//days
export const AMOUNT_OF_DAYS_IN_WEEK = 7;
//days
export const AMOUNT_OF_DAYS_IN_MONTH = 30;
//days
export const AMOUNT_OF_DAYS_IN_THREE_MONTHS = 90;
//days
export const AMOUNT_OF_DAYS_IN_SIX_MONTHS = 180;
//# sourceMappingURL=time.js.map